import { formatActionText } from 'pages/WellGuardian/WIR/utils';
import {
  REACTIVE_SCOPE_ACTION_LABEL,
  WIRCreateJourneyStepsKeys,
  WIRReactiveScopeSectionKey,
  WIRReactiveScopeSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR, WIRActionStatus } from 'types/wellGuardian';

const fixedDate = new Date('2023-03-13T00:00:59.349Z'); // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.

export const getReactiveScopeSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.iraq) {
    return (
      (wir &&
        Object.keys(WIRReactiveScopeSections)
          .map(item => ({
            label: WIRReactiveScopeSections[item as WIRReactiveScopeSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.REACTIVE_SCOPE,
          }))
          .filter(stepItem =>
            stepItem.label === WIRReactiveScopeSections.initialRequestInformation ||
            stepItem.label === WIRReactiveScopeSections.organiseKickOffMeeting ||
            stepItem.label === WIRReactiveScopeSections.reviewChecklistActions ||
            stepItem.label === WIRReactiveScopeSections.wellInformation ||
            stepItem.label === WIRReactiveScopeSections.equipmentIdentification ||
            (wir.startDate && // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.
              new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
              stepItem.label === WIRReactiveScopeSections.interventionStrategyDefined) ||
            stepItem.label === WIRReactiveScopeSections.afeApproved ||
            stepItem.label === WIRReactiveScopeSections.managerialSummary ||
            stepItem.label === WIRReactiveScopeSections.equipmentPreparation ||
            stepItem.label === WIRReactiveScopeSections.programmeReview ||
            stepItem.label === WIRReactiveScopeSections.programmeDistributed ||
            stepItem.label === WIRReactiveScopeSections.finalWirSignOff
              ? true
              : wir?.actions?.some(
                  item =>
                    item.actionName ===
                      formatActionText(stepItem.label, REACTIVE_SCOPE_ACTION_LABEL) &&
                    item.state !== WIRActionStatus.DELETED,
                ),
          )) ??
      []
    );
  } else {
    return (
      (wir &&
        Object.keys(WIRReactiveScopeSections)
          .map(item => ({
            label: WIRReactiveScopeSections[item as WIRReactiveScopeSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.REACTIVE_SCOPE,
          }))
          .filter(stepItem =>
            stepItem.label === WIRReactiveScopeSections.initialRequestInformation ||
            stepItem.label === WIRReactiveScopeSections.organiseKickOffMeeting ||
            stepItem.label === WIRReactiveScopeSections.reviewChecklistActions ||
            stepItem.label === WIRReactiveScopeSections.wellInformation ||
            stepItem.label === WIRReactiveScopeSections.vendorEngagementSelection ||
            stepItem.label === WIRReactiveScopeSections.equipmentIdentification ||
            // stepItem.label === WIRReactiveScopeSections.programmeCreated ||
            // stepItem.label === WIRReactiveScopeSections.workInstructionCreated ||
            (wir.startDate && // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.
              new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
              stepItem.label === WIRReactiveScopeSections.interventionStrategyDefined) ||
            stepItem.label === WIRReactiveScopeSections.afeApproved ||
            stepItem.label === WIRReactiveScopeSections.managerialSummary ||
            stepItem.label === WIRReactiveScopeSections.equipmentPreparation ||
            stepItem.label === WIRReactiveScopeSections.programmeReview ||
            stepItem.label === WIRReactiveScopeSections.programmeDistributed ||
            stepItem.label === WIRReactiveScopeSections.finalWirSignOff
              ? true
              : wir?.actions?.some(
                  item =>
                    item.actionName ===
                      formatActionText(stepItem.label, REACTIVE_SCOPE_ACTION_LABEL) &&
                    item.state !== WIRActionStatus.DELETED,
                ),
          )) ??
      []
    );
  }
};
